import * as React from 'react'
import {FC} from 'react'
// @ts-ignore
import ControlBlock, {ControlBlockPropsInterface} from '../control-block'

const ControlBlockModeSwitch: FC<ControlBlockPropsInterface> = ({
    currentStep,
    onNextClick,
    onPrevClick,
    nextDisabled,
}) => {
    return (
        <div className='e-smart-padding-left'>
            <ControlBlock
                currentStep={currentStep}
                onNextClick={onNextClick}
                onPrevClick={onPrevClick}
                nextDisabled={nextDisabled}
            />
        </div>
    )
}

export default ControlBlockModeSwitch
